import React, { useRef, useState } from "react";
import { auth } from "../../../firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";

import SEO from '../../SEO';
import Popup from "../../mobile/Popup";

import styleClasses from '../css/mobile/LoginSignUp.module.scss';

function ForgotPassword() {
  const emailRef      = useRef();
  const isSubmitting  = useRef(false);

  const navigate      = useNavigate();

  const [email, setEmail]                     = useState("");
  const [message, setMessage]                 = useState("");
  const [emailError, setEmailError]           = useState('');
  const [emailErrorText, setEmailErrorText]   = useState('');
  const [buttonLoading, setButtonLoading]     = useState(false);
  const [error, setError]                     = useState("");
  const [openPopup, setOpenPopup]             = useState(false);
  const [popupTitle, setPopupTitle]           = useState('');
  const [popupText, setPopupText]             = useState('');
  const [popupFunction, setPopupFunction]     = useState('');
  const [popupButtonText, setPopupButtonText] = useState('');

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const resetError = (event) => {
    if (event.target.id === 'email') {
      setEmailError('');
      setEmailErrorText('');
    }
    setMessage('');
    setError('');
  };

  const handleResetPassword = async () => {
    if (!email) {
      setEmailError('error');
      setEmailErrorText("이메일을 입력하세요.");
      emailRef.current.focus();
      return;
    } else if (!validateEmail(email)) {
      setEmailError('error');
      setEmailErrorText('올바른 이메일 주소를 입력하세요.');
      emailRef.current.focus();
      return;
    }

    try {
      if (isSubmitting.current) return; // 실행 중일 경우 중복 클릭 방지
      isSubmitting.current = true;      // 버튼 비활성화
      setButtonLoading(true);           // 버튼 로딩 표시

      await sendPasswordResetEmail(auth, email);
      
      setEmail('');
      setPopupTitle('비밀번호 재설정 링크가 이메일로 전송되었습니다.');
      setPopupText('');
      setPopupFunction(() => () => navigate('/'));
      setPopupButtonText('메인으로 이동');
      setOpenPopup(true);
      isSubmitting.current = false;   // 버튼 활성화
      setButtonLoading(false);        // 버튼 로딩 숨김
    } catch (err) {
      isSubmitting.current = false;   // 버튼 활성화
      setButtonLoading(false);        // 버튼 로딩 숨김
      setError("비밀번호 재설정 요청 실패: " + err.message);
      setMessage("");
    }
  };

  return (
    <>
      <SEO title='비밀번호 재설정' />
      <div className={ styleClasses.loginMobile }>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.title }>
            <h1>비밀번호 재설정</h1>
          </div>
          <div className="commonForm">
            <div className="formRow fullWidth">
              <div className="labelBox">
                <label htmlFor="email">ID (이메일)</label>
              </div>
              <div className={`fieldBox ${ emailError }`}>
                <input type="email" id="email" ref={ emailRef } value={ email } placeholder="이메일을 입력하세요" onChange={ (e) => { setEmail(e.target.value); resetError(e); } } />
                <div className="fieldError">
                  <p>{ emailErrorText }</p>
                </div>
              </div>
            </div>
            { error && <p className={ styleClasses.loginError }>{ error }</p> }
            <div className='commonButton fullWidth'>
              <button className="black" onClick={handleResetPassword}>
                비밀번호 재설정
                <div className={`buttonLoading ${ buttonLoading && 'active' }`}>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </button>
            </div>
            {message && <p style={{ color: "green" }}>{message}</p>}
          </div>
        </div>
      </div>
      <Popup open={ openPopup } setOpenPopup={ setOpenPopup } title={ popupTitle } text={ popupText } buttonText={ popupButtonText } buttonFunction={ popupFunction } />
    </>
  );
}

export default ForgotPassword;
